import { teal } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import React from 'react';
import AboutSelect from '../../components/About/AboutSelect';
import PrivacyText from '../../components/About/Texts/Privacy';
import Footer from '../../components/General/Footer';
import HeaderCard from '../../components/General/HeaderCard';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import withApollo from '../../lib/withApollo';

const PrivacyPage = () => {
  const title = 'Privacy';
  return (
    <>
      <Header subheader={title} active="privacy" />
      <Head title={`${title}`} />
      <AboutSelect selection={6} />
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        className="pt-4 pb-4"
      >
        <Grid item lg={7} md={8} sm={11} xs={12}>
          <HeaderCard
            title="Privacy Policy"
            background={teal[600]}
            content={<PrivacyText />}
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default withApollo(PrivacyPage);
